export enum AssetFunctionEnum {
  SCHOOL = 'school',
  HOSPITAL = 'hospital',
  UNDEFINED = 'undefined',
}
